import i18next from 'i18next'
import XHRBackend from 'i18next-xhr-backend'
import moment from 'moment'
import momentLocaleTh from 'moment/locale/th'
import momentLocaleZhHk from 'moment/locale/zh-hk'

// import other moment locales as needed

i18next
	.use(XHRBackend)
	.on('languageChanged', locale => {
		// Update moment's locale on language changed.
		let momentLocale = locale.toLowerCase()
		if (!momentLocale.startsWith('zh')) {
			momentLocale = momentLocale.split('-')[0]
		}
		moment.updateLocale(momentLocale, [
			momentLocaleZhHk,
			momentLocaleTh /*, add other moment locales as needed */
		])
	})
	.init({
		preload: ['en-HK'],
		fallbackLng: 'en-HK',
		backend: {
			loadPath: `/locales/{lng}.json`,
			queryStringParams: {
				version: process.env.VUE_APP_VERSION
			}
		},
		interpolation: {
			prefix: '{',
			suffix: '}'
		}
	})

export default i18next
